module.exports = __webpack_public_path__ + "img/home29.22abfd99.png";